import type PptxGenJS from "pptxgenjs";

export type PptxGenConstructor = typeof PptxGenJS;

/** Load PptxGenJS with resilient default interop (ESM/CJS/UMD). */
export async function loadPptxGenConstructor(): Promise<PptxGenConstructor> {
  const mod = await import("pptxgenjs");
  const ctor =
    (mod as { default?: PptxGenConstructor }).default ??
    (mod as { PptxGenJS?: PptxGenConstructor }).PptxGenJS;
  if (!ctor) {
    throw new Error("PptxGenJS non disponibile (export default mancante)");
  }
  return ctor;
}
